export const ROLE_ADS = 'ROLE_ADS';
export const ROLE_COORD_ADS = 'ROLE_COORD_ADS';
export const ROLE_KAM = 'ROLE_KAM';
export const ROLE_ADMIN = 'ROLE_ADMIN';
